import { useEffect, useState } from 'react';
import type { MediaImageDto } from '@jordan/types';
import { Modal, Spinner } from '@jordan/ui';
import { apiGet, assetUrl } from '../lib/api';

interface MediaPickerProps {
  open: boolean;
  onClose: () => void;
  onSelect: (image: MediaImageDto) => void;
}

/** Modal that lists the shared Media Library so the user can pick an image. */
export function MediaPicker({ open, onClose, onSelect }: MediaPickerProps) {
  const [items, setItems] = useState<MediaImageDto[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    if (!open) return;
    setItems(null);
    setErr(null);
    apiGet<MediaImageDto[]>('/api/media')
      .then(setItems)
      .catch(() => setErr('Could not load the Media Library.'));
  }, [open]);

  if (!open) return null;

  return (
    <Modal title="Choose from Media Library" open={open} onClose={onClose} size="lg">
      {err && <div className="text-danger mb-3">{err}</div>}
      {!items && !err && <Spinner />}
      {items && items.length === 0 && (
        <p className="text-muted mb-0">No images yet. Upload one from the Media Library.</p>
      )}
      <div className="row g-2">
        {items?.map((img) => (
          <div className="col-4 col-md-3" key={img.id}>
            <button
              type="button"
              className="btn btn-light w-100 p-1 border"
              title={img.label}
              onClick={() => onSelect(img)}
            >
              <img
                src={assetUrl(img.url)}
                alt={img.label}
                className="w-100 rounded"
                style={{ height: 96, objectFit: 'cover' }}
              />
              <div className="text-truncate fs-sm mt-1">{img.label}</div>
            </button>
          </div>
        ))}
      </div>
    </Modal>
  );
}
